import { TimekeeperService } from "services/TimekeeperService";

const tk = new TimekeeperService();

type SetLoading = (loading: boolean) => void;
type SetRows = (rows: any[]) => void;

const gettingPaycodes = async (
    setLoading: SetLoading,
    setRows: SetRows,
    type: string | undefined = undefined
): Promise<void> => {
    setLoading(true);
    tk.paycodes.getPaycodes(type)
        .then((response) => {
            setRows(response);
        })
        .catch((error) => {
            console.error(error.message);
        })
        .finally(() => {
            setLoading(false);
        });
}

export {
    gettingPaycodes
}
